





































import { COLLECTION_ORGANIZATIONS, COLLECTION_USERS } from '@/model/AppConstants';
import FirebaseUtil from '@/model/FirebaseUtil';
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Followers extends Vue {
  mounted() {
    if (this.org.followers.length) {
      this.$store.dispatch('bindOrgFollowers', this.org.followers);
    }
  }

  accepted(item: any) {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    clone.members.push(item.uid);
    const index = clone.unApprovedMembers.findIndex((id: any) => (id === item.uid));
    clone.unApprovedMembers.splice(index, 1);
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
  }

  deleted(item: any) {
    const clone = { ...this.org };
    clone.moderator = FirebaseUtil.ObjectToRef(COLLECTION_USERS, this.org.moderator.id);
    const index = clone.unApprovedMembers.findIndex((id: any) => (id === item.uid));
    clone.unApprovedMembers.splice(index, 1);
    this.$store.dispatch('updateCollection', {
      collection: COLLECTION_ORGANIZATIONS,
      doc: this.org.id,
      payload: clone,
    });
  }

  get org() {
    return this.$store.state.orgObj;
  }

  get followers() {
    return this.$store.state.orgFollowers;
  }

  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }
}
